import createParseMiddleware from './createParseMiddleware';
import { parseAgreementResponse, parseAgreementContentResponse } from 'utils/apiParser/agreementParser';
import { Agreement, AgreementContent } from 'types/agreementTypes';

export const parseFetchAgreementsMiddleware = createParseMiddleware<Agreement>(parseAgreementResponse, 'agreements/fetchAgreements');
export const parseDescribeAgreementMiddleware = createParseMiddleware<Agreement>(parseAgreementResponse, 'agreements/describeAgreement');
export const parseDescribeAgreementContentMiddleware = createParseMiddleware<AgreementContent>(parseAgreementContentResponse, 'agreements/describeAgreementContent');
